<template>
  <div class="content">
    <LinkPath current-path="análise de fraude"/>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">
              <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

              <div v-if="stringDivMessage !== ''" v-bind:class="[ 'alert' , classDivMessage]" role="alert"
                   style="margin: 16px">{{ stringDivMessage }}
              </div>

              <div class="form-row input-row" style="align-items: end">
                <div class="col-md-3 mb-3" style="margin-top: 5px;">
                  <label for="dataIni">Data Início</label>
                  <div class="input-group">
                        <span class="input-group-addon date-input">
                            <i class="fa fa-fw fa-calendar"></i>
                        </span>
                    <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtIni"
                                id="dataIni" width="100%" required></datepicker>
                  </div>
                </div>
                <div class="col-md-3 mb-3" style="margin-top: 5px;">
                  <label for="dateFim">Data Fim</label>
                  <div class="input-group">
                        <span class="input-group-addon date-input">
                            <i class="fa fa-fw fa-calendar"></i>
                        </span>
                    <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtFim"
                                id="dateFim" width="100%" required></datepicker>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <button id="btnPesq" type="button" class="btn btn-primary button-color input-space"
                          v-on:click="findFrauds()">Pesquisar
                  </button>
                  <button type="button" class="btn btn-secondary input-space"
                          v-on:click="clearFilter()">Limpar Filtros
                  </button>
                </div>
              </div>

              <div class="form-row input-row" style="gap: 1rem">

                <div class="col-md-3 mb-3">
                  <div class="row">
                    <label for="safcode">
                      Código SAF
                    </label>
                    <input type="text" id="safcode" class="input-spacing" v-model="safCode"/>
                  </div>
                </div>

                <div class="col-md-3 mb-3">
                  <div class="row">
                    <label for="status">
                      Status
                    </label>
                    <select id="status" class="input-spacing" v-model="status">
                      <option value=""></option>
                      <option value="IN_ANALISIS">Em análise</option>
                      <option value="FRAUD_CONFIRMED">Fraude confirmada</option>
                      <option value="FRAUD_NOT_CONFIRMED">Fraude não confirmada</option>
                    </select>
                  </div>
                </div>

              </div>

              <div style="clear:both;"></div>
            </div>

            <a id="editFraud" class="btn btn-primary" style="display: none;" data-toggle="divViewFraud" href="#divViewFraud"
               v-on:click="toggleClassByName('show', '#divViewFraud')" role="button"
               data-target="#divViewFraud" aria-expanded="false" aria-controls="divViewFraud"/>

            <div class="box box-info .collapse" id="divViewFraud"
                 style="margin-top: 5px; margin-bottom: 5px; margin-left: 1.5%; width: 97%; display: none">

              <h3>Editar registro de Fraude</h3>

              <div class="col-md-10 mb-3">
                <label for="statusEdit">Detalhes</label>
                <ul>
                  <li><b>IDN:</b> {{ fraudEdit.idn }}</li>
                  <li><b>CPF:</b> {{ fraudEdit.cpf }}</li>
                </ul>
              </div>
              <div class="form-row" style="margin-top: 5px;">
                <div class="col-md-6 mb-3">
                  <label for="safCodeEdit">Código SAF</label>
                  <input type="text" class="form-control" id="safCodeEdit" v-model="fraudEdit.safCode" readonly>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="statusEdit">Status</label>
                  <select id="statusEdit" class="input-spacing" v-model="fraudEdit.status"
                          :disabled="hideStatusButton">
                    <option value="IN_ANALISIS">Em análise</option>
                    <option value="FRAUD_CONFIRMED">Fraude confirmada</option>
                    <option value="FRAUD_NOT_CONFIRMED">Fraude não confirmada</option>
                  </select>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-5 mb-3" style="margin-top:5px; display: flex; flex-direction: column; gap: 1rem">
                  <label for="description">Descrição</label>
                  <textarea rows="6" cols="80" id="description" v-model="fraudEdit.description" readonly/>
                </div>

                <div class="col-md-5 mb-3" style="margin-top:5px; margin-left: 8%; display: flex; flex-direction: column; gap: 1rem">
                  <label for="conclusion">Conclusão</label>
                  <textarea v-if="!fraudEdit.userAudit" rows="6" cols="80" id="conclusion"
                            v-model="fraudEdit.conclusion" :disabled="hideStatusButton"/>
                  <textarea v-if="fraudEdit.userAudit" rows="6" cols="80" id="conclusion" v-model="fraudEdit.conclusion"
                            readonly/>
                </div>
              </div>

              <div class="col-md-9 mb-1" style="margin-bottom: 5px; margin-left: -1.5%;">
                <!-- <div class="form-group" > -->
                <div v-if="check('SAVE') && !hideSaveButton && !hideStatusButton" class="col-md-1 mb-3">
                  <button type="submit" v-on:click="save($event)" class="btn btn-primary">Salvar</button>
                </div>
                <div class="col-md-1 mb-3" style="margin-left: 5px;">
                  <button type="button" v-on:click="cancelEdit()" class="btn btn-secondary">Cancelar</button>
                </div>
                <!-- </div>  -->
              </div>
              <div style="clear:both;"></div>
            </div>

            <div id="divblank" class="divBlank">
              <div id="divTab" style="display:none;">
                <div class="row center-block">
                  <div class="col-md-12">
                    <div class="box">

                      <!-- /.box-header -->
                      <div class="box-body">
                        <div class="dataTables_wrapper form-inline dt-bootstrap" id="tabFraud_wrapper">
                          <div class="row">
                            <div class="col-sm-6">
                              <div id="tabFraud_length" class="dataTables_length">

                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 table-responsive">
                              <table aria-describedby="tabFraud" role="grid" id="tabFraud"
                                     class="table table-bordered table-striped dataTable">
                                <thead>
                                <tr role="row">
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Ação</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Data/Hora</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Reportado por</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Código SAF</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Analisado por</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Status</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">NIST</th>
                                  <th colspan="1" rowspan="1" aria-controls="tabFraud" tabindex="0">Processado</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(fraud, index) in listaFraud" :key="fraud.id" class="even" role="row">
                                  <td><a href="#" v-on:click="editFraud(index)" title="Visualizar Ocorrência"><i
                                    class="fa fa-eye" style="margin-left: 35%;"/></a></td>
                                  <td data-sort="<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>">
                                    {{ fraud.formatCreationDate }}
                                  </td>
                                  <td>{{ fraud.user }}</td>
                                  <td>{{ fraud.safCode }}</td>
                                  <td>{{ fraud.userAudit }}</td>
                                  <td>{{ fraud.translateStatus }}</td>
                                  <td>
                                    <a href="#" v-on:click="downloadNist(fraud)" title="Download Nist">NIST</a>
                                  </td>
                                  <td>
                                    <a href="#" v-if="!fraud.process && fraud.userAudit !== ''"
                                       v-on:click="preSend(fraud.id)" title="Ação não processada ou com erro."
                                       data-toggle="modal" data-target="#fraudeModal">
                                      <i class="fa fa-times-circle" aria-hidden="true" style="margin-left: 35%;"/>
                                    </a>
                                    <a href="#" v-if="fraud.process" title="Ação processada com sucesso.">
                                      <i class="fa fa-check-circle" aria-hidden="true" style="margin-left: 35%;"/>
                                    </a>
                                    <a href="#" v-if="!fraud.process && fraud.userAudit === ''"
                                       title="Ação aguardando análise.">
                                      <i class="fa fa-exclamation-circle" aria-hidden="true" style="margin-left: 35%;"/>
                                    </a>
                                  </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                  <th colspan="1" rowspan="1">Ação</th>
                                  <th colspan="1" rowspan="1">Data/Hora</th>
                                  <th colspan="1" rowspan="1">Reportado por</th>
                                  <th colspan="1" rowspan="1">Código SAF</th>
                                  <th colspan="1" rowspan="1">Analisado por</th>
                                  <th colspan="1" rowspan="1">Status</th>
                                  <th colspan="1" rowspan="1">NIST</th>
                                  <th colspan="1" rowspan="1">Processado</th>
                                </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- /.box-body -->
                        <div style="clear:both;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fraud modal -->
            <div class="modal fade" id="fraudeModal" tabindex="-1" role="dialog" aria-labelledby="fraudeModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header" style="background-color: #3c8dbc;">
                    <h4 class="modal-title" id="fraudeModalLabel" style="color: white; font-weight: bold;">Registro de
                      Fraude</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p style="font-size: 16px;">Deseja reenviar para processamento?</p>

                    <div style="clear:both;"></div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" v-on:click="reProcessing()" data-dismiss="modal" class="btn btn-primary">
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import interceptor from '../../interceptor'
import roles from '../../roles'
import Fraude from '../../model/Fraude'
import LinkPath from '../components/LinkPath'

export default {
  name: 'Fraude',
  data: function () {
    return {
      listaFraud: [],
      fraudEdit: new Fraude(),
      dtIni: '',
      dtFim: '',
      id: '',
      ptBR: ptBR,
      suspect: false,
      safCode: '',
      status: '',
      key: 'FRAUD',
      sessionUser: '',
      user: '',
      userAudit: '',
      classDivMessage: 'alert-success',
      classDivMessage2: 'alert-warning',
      stringDivMessage: '',
      hideSaveButton: false,
      hideStatusButton: false
    }
  },
  components: {
    LinkPath,
    Datepicker
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    findFrauds: function () {
      $('#btnPesq').attr('disabled', true)
      this.clear()
      this.clearList()
      if ((this.dtIni !== '' && this.dtFim === '') || (this.dtFim !== '' && this.dtIni === '')) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Para pesquisar utilizando um período ambas as datas devem ser preenchidas. </p>')
          .show()
      } else if (this.dtIni > this.dtFim) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Data Início não pode ser maior que Data Fim. </p>')
          .show()
      } else {
        var URL = 'api/v1/fraud/listfraud'
        if (this.dtIni !== '' && this.dtFim !== '') {
          var dtIni = this.formatDate(this.dtIni)
          var dtFim = this.formatDate(this.dtFim)
          URL += '?dtIni=' + dtIni + '&dtFim=' + dtFim + '&status=' + this.status + '&safCode=' + this.safCode
        } else {
          URL += '?status=' + this.status + '&safCode=' + this.safCode
        }
        interceptor.request('get', URL, {})
          .then(response => {
            this.listaFraud = response.data
            if (this.listaFraud.length > 0) {
              this.refreshData()
              this.$nextTick(() => {
                $('#tabFraud').DataTable({
                  'oLanguage': {
                    'sUrl': '/static/json/languageDataTable.json'
                  }
                })
              })
              $('#divblank').attr('class', '')
              $('#divTab').show()
            }
          })
          .catch(function (error) {
            if (error.response.status === 404) {
              $('#divAlert').attr('class', 'alert alert-warning')
                .append('<p style="font-weight: bold;">Não foram encontrados registros para esta pesquisa. </p>')
                .show()
            } else {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Erro ao tentar pesquisar os registros. Serviço indisponível. </p>')
                .show()
            }
            this.$nextTick(() => {
              $('#tabFraud').DataTable({
                'oLanguage': {
                  'sUrl': '/static/json/languageDataTable.json'
                }
              }).destroy()
            })
          })
      }
      setTimeout(() => $('#btnPesq').attr('disabled', false), 2000)
    },
    limparInputs: function () {
      this.stringDivMessage = ''
      this.hideSaveButton = false
      this.hideStatusButton = false
    },
    editFraud: function (index) {
      this.limparInputs()
      let sessionUser = localStorage.getItem('usercod')
      this.fraudEdit = this.listaFraud[index]
      if (this.fraudEdit.user === sessionUser) {
        this.stringDivMessage = `O mesmo usuário não pode efetuar mais de uma análise para o mesmo registro.`
        this.classDivMessage = 'alert-warning'
        this.hideSaveButton = true
        this.hideStatusButton = true
      }
      if (this.fraudEdit.status === 'FRAUD_NOT_CONFIRMED' && 'FRAUD_CONFIRMED') {
        this.stringDivMessage = `Esta análise de fraude se encontra finalizada como: ` + this.fraudEdit.translateStatus
        this.classDivMessage = 'alert-warning'
        this.hideStatusButton = true
      }
      var classe = $('#divViewFraud').attr('class')
      if (classe !== 'collapse in') {
        document.getElementById('editFraud').click()
      }
    },
    cancelEdit: function () {
      this.fraudEdit = new Fraude()
      document.getElementById('editFraud').click()
      this.limparInputs()
    },
    save: function (event) {
      this.clear()
      event.preventDefault()
      if (this.fraudEdit.conclusion === '') {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">O campo conclusão é de preenchimento obrigatório.</p>')
          .show()
      } else if (this.fraudEdit.status === 'IN_ANALISIS') {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Para atualizar o registro o status deve ser diferente de "Em análise".</p>')
          .show()
      } else {
        this.fraudEdit.userAudit = window.localStorage.getItem('usercod')
        interceptor.request('post', 'api/v1/fraud/fraudsaveinno', this.fraudEdit)
          .then(response => {
            this.cancelEdit()
            $('#divAlert').attr('class', 'alert alert-success').append('<p style="font-weight: bold;">Registro de fraude atualizado com sucesso.</p>').show()
          })
          .catch(function (error) {
            var msg = error.response.status
            if (msg === 404) {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;"> Erro ao tentar atualizar o registro. Serviço não encontrado.</p>')
                .show()
            } else if (msg === 500) {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Erro ao tentar atualizar o registro. Serviço indisponível </p>')
                .show()
            } else {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Serviço indisponível </p>')
                .show()
            }
          })
      }
    },
    preSend: function (id) {
      this.id = id
    },
    reProcessing: function () {
      interceptor.request('post', 'api/v1/fraud/resend', this.id)
        .then(response => {
          $('#divAlert').attr('class', 'alert alert-success').append('<p style="font-weight: bold;">Registro de fraude reenviado com sucesso. Aguarde alguns minutos para verificar o processamento.</p>').show()
          this.id = ''
        })
        .catch(function (error) {
          var msg = error.response.status
          if (msg === 404) {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;"> Erro ao tentar reenviar o registro. Serviço não encontrado.</p>')
              .show()
          } else if (msg === 500) {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;">Erro ao tentar reenviar o registro. Serviço indisponível </p>')
              .show()
          } else {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;">Serviço indisponível </p>')
              .show()
          }
        })
    },
    downloadNist: function (fraud) {
      var base64 = fraud.nistFile
      var link = document.createElement('a')
      link.href = 'data:application/eft;base64,' + base64
      link.download = fraud.safCode + '.eft'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    formatDate: function (date) {
      var day = date.getDate()
      var month = date.getMonth() + 1
      var year = date.getFullYear()
      return day + '-' + month + '-' + year
    },
    clear: function () {
      $('#divAlert').empty().hide()
      $('#divTab').hide()
    },
    drawDT() {
      $('#tabFraud').DataTable().draw()
    },
    async refreshData() {
      this.isLoading = true
      $('#tabFraud').DataTable().destroy()
      try {
        await this.$nextTick(this.drawDT)
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    clearList: function () {
      this.listAudit = []
    },
    clearFilter: function () {
      this.clear()
      this.clearList()
      this.status = ''
      this.safCode = ''
      this.dtIni = ''
      this.dtFim = ''
      location.reload()
    }
  }
}

</script>

<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/


table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.divBlank {
  background-color: white;
  height: 200px !important;
}

.input-space {
  height: 36px;
}

</style>




// WEBPACK FOOTER //
// Fraud.vue?30202aaf